var map = {
	"./bigTruck/bigTruck-dark-grey.png": "48ff",
	"./bus/bus-dark-grey.png": "e223",
	"./car/car-dark-grey.png": "6316",
	"./container/container-dark-grey.png": "33ab",
	"./doubleCabin/doubleCabin-dark-grey.png": "4ea0",
	"./electricCar/electricCar-dark-grey.png": "9873",
	"./electricMotorcycle/electricMotorcycle-dark-grey.png": "60e2",
	"./excavator/excavator-dark-grey.png": "c550",
	"./motorcycle/motorcycle-dark-grey.png": "b8a6",
	"./smallTruck/smallTruck-dark-grey.png": "b437",
	"./tractor/tractor-dark-grey.png": "2d98",
	"./truckHead/truckHead-dark-grey.png": "8bf1",
	"./van/van-dark-grey.png": "ebe9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37c3";